<template>
  <div>
    <breadcrumb-header
      v-if="withBreadcrumbs"
      :items="breadcrumbs"
    />
    <v-tabs
      v-if="store?.images?.length"
      v-model="tab"
    >
      <smpw-tab
        value="info"
        :active="tab === 'store_info'"
        :text="t('global.info')"
      />
      <smpw-tab
        v-if="store?.images?.length"
        value="images"
        :active="tab === 'images'"
        :text="t('images.title', 2)"
      />
    </v-tabs>
    <v-window
      v-if="store"
      v-model="tab"
    >
      <v-window-item value="info">
        <rich-text-content
          v-if="store.details"
          :data="store.details"
          class="mb-5"
        />
        <store-marker
          v-if="showMap"
          v-model="store"
          read-only
        />

        <v-card>
          <v-toolbar
            color="primary"
          >
            <v-icon
              icon="fas fa-warehouse"
              class="mx-5"
            />
            <span>{{ t('store.title') }}</span>
          </v-toolbar>
          <div class="d-flex flex-row justify-space-between align-center my-2">
            <div class="d-flex flex-row align-center">
              <v-img
                :width="40"
                :height="40"
                inline
                class="mr-2"
                src="/images/mapmarkers/pin_store.png"
              />
              <p class="font-weight-bold">
                {{ store.name }}
              </p>
            </div>
            <div class="d-flex flex-column flex-sm-row align-center">
              <v-btn
                :href="`https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`"
                target="_blank"
                prepend-icon="fas fa-compass"
                :text="t('global.directions')"
                color="primary"
                :class="smAndDown ? 'mt-1' : ''"
                class="me-1"
              />
              <image-slideshow
                v-if="store.images && store.images.length > 0"
                :as-dialog="true"
                button-color="primary"
                :class="smAndDown ? 'mt-1' : ''"
                :images="store.images.map((image) => ({ href: image.signed_file_url }))"
              />
            </div>
          </div>
        </v-card>
      </v-window-item>
      <v-window-item value="images">
        <image-gallery
          v-if="store.images?.length"
          v-model="store.images"
          enable-slide-show
          read-only
        />
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { useErrorStore } from '@/stores/errors';
import axios from 'axios';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import ImageGallery from '../images/ImageGallery.vue';
import ImageSlideshow from '../images/ImageSlideshow.vue';
import RichTextContent from '../RichTextContent.vue';
import StoreMarker from './StoreMarker.vue';

const props = withDefaults(defineProps<{
  id: string | number;
  withBreadcrumbs?: boolean;
  showMap?: boolean;
}>(), {
  withBreadcrumbs: () => true,
  showMap: () => true,
});

const { smAndDown } = useDisplay();
const { t } = useI18n();
const { handleError } = useErrorStore();
const store = ref<App.Models.Store | null>();
const tab = ref('info');
const breadcrumbs = computed(() => [
  {
    title: t('store.and_locations'),
    to: '/locations',
  },
  {
    title: store.value?.name ?? t('states.loading'),
  },
]);

async function loadStore() {
  try {
    const response = await axios.get(`/api/stores/${props.id}?inc[]=images`);
    store.value = response.data.data;
  }
  catch (error) {
    handleError(error, t('store.cannot_load'));
  }
}

loadStore();
</script>
